module.exports = __webpack_public_path__ + "img/_TheDash.d5ff195a.png";